@if (isEnabled) {
    <section
        class="sir-countdown-timer"
        role="timer"
        [attr.aria-label]="'countdown.ariaLabel' | translate"
        aria-atomic="true">
        <ul class="sir-countdown-segments">
            <li class="sir-countdown-segment">
                <span class="sir-countdown-value sir-text-style-paragraph-l-default">{{ formattedTime.days }}</span>
                <span class="sir-countdown-label sir-text-style-system-s-default">{{ 'countdown.days' | translate }}</span>
            </li>
            <li class="sir-countdown-segment">
                <span class="sir-countdown-value sir-text-style-paragraph-l-default">{{ formattedTime.hours }}</span>
                <span class="sir-countdown-label sir-text-style-system-s-default">{{ 'countdown.hours' | translate }}</span>
            </li>
            <li class="sir-countdown-segment">
                <span class="sir-countdown-value sir-text-style-paragraph-l-default">{{ formattedTime.minutes }}</span>
                <span class="sir-countdown-label sir-text-style-system-s-default">{{ 'countdown.minutes' | translate }}</span>
            </li>
        </ul>
    </section>
}
